/**
 * Immediate logout utility for synchronous Redux state reset
 * This ensures all user data is immediately cleared without any delay
 */

import { store } from 'redux/store'

/**
 * Immediately resets ALL Redux state to initial values
 * This is synchronous and happens before any async operations
 */
export const immediateReduxReset = () => {
  // Get current state
  const state = store.getState()

  // Dispatch actions to clear all slices immediately
  try {
    const dispatch = store.dispatch

    // Clear main states
    dispatch({ type: 'allGuarantees/clearGuarantees' })
    dispatch({ type: 'legalEntities/clearAllLegalEntites' })
    dispatch({ type: 'notifications/clearAllNotifications' })
    dispatch({ type: 'termsReducer/clearAllTermsConditions' })
    dispatch({ type: 'userReducer/clearUserDetails' })
    dispatch({ type: 'purposeTypes/clearAllPurposeTypes' })
    dispatch({ type: 'contractPdfReducer/clearContractPdf' })
    dispatch({ type: 'contractHistory/clearContractHistory' })
    dispatch({ type: 'createGuarantee/clearGuaranteeRequest' })
    dispatch({ type: 'adminCreateActions/clearAllAdminCreateActions' })
    dispatch({ type: 'createPayload/clearGuaranteePayload' })
    dispatch({ type: 'sponsoredEntity/clearSponsoredEntity' })
    dispatch({ type: 'amendmentNotification/resetAmendment' })

    // Clear sessionStorage immediately
    sessionStorage.clear()

    console.log('Redux state immediately reset and sessionStorage cleared')
  } catch (error) {
    console.error('Error during immediate Redux reset:', error)
  }
}

/**
 * Waits for Redux state to be completely cleared
 * Used to ensure logout completes before navigation
 */
export const waitForReduxReset = (timeout: number = 100): Promise<void> => {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve()
    }, timeout)
  })
}

/**
 * Force reload entire app state (nuclear option if needed)
 */
export const forceFullAppStateReset = () => {
  // Clear everything
  sessionStorage.clear()
  localStorage.removeItem('guaranteeFormData')

  // Clear Redux
  immediateReduxReset()

  // Hard page reload to ensure clean state
  window.location.href = '/auth/login'
}
